import "../css/bootstrap@3.3.7.min.css";

import "../css/help.css";
import "../css/theme.css";
import { scrollToAnchor } from "../js/scrollToAnchor";
import "../js/catalog";

$("header").load("./ajax/header.html", function () {
  var anchor = window.location.hash;
  if (anchor) {
    scrollToAnchor(anchor);
  }
});
$("footer").load("./ajax/footer.html");

lazyload();
addMouseWheelEvent();

function addMouseWheelEvent() {
  if ("object" === typeof document.onmousewheel) {
    document.onmousewheel = (e) => {
      autoplay(e);
    };
    // document.addEventListener("mousewheel", (e)=>{
    //     autoplay(e)
    // });
  } else {
    // firefox: typeof element.onmousewheel === "undefine"
    document.addEventListener("DOMMouseScroll", (e) => {
      autoplay(e);
    });
  }
}

function autoplay(e) {
  var startY = getElementToPageTop(document.getElementById("how-to-use"));
  var video = document.getElementById("helpVideo");
  var videoHeight = video.offsetHeight;
  var stopY = startY + videoHeight;
  if (startY <= e.pageY <= stopY) {
    if (video.paused) {
      video.play();
    }
  } else {
    if (!video.paused) {
      video.pause();
    }
  }
}

function getElementToPageTop(el) {
  if (el.parentElement) {
    return getElementToPageTop(el.parentElement) + el.offsetTop;
  }
  return el.offsetTop;
}
